import strings from 'utils/strings'
import { M0, M1, M2 } from 'utils/constants'
import { mapFrom } from 'utils/functional'

export const timerModeDescriptions = mapFrom({
  [M0]: [
    strings.feature_timer_countdown_start_text,
    strings.feature_timer_reach_zero_restart_text,
    strings.feature_timer_activate_restart_text,
    strings.feature_timer_reset_text,
  ],
  [M1]: [
    strings.feature_timer_countdown_start_text,
    strings.feature_timer_reach_zero_hold_text,
    strings.feature_timer_activate_hold_text,
    strings.feature_timer_reset_text,
  ],
  [M2]: [
    strings.feature_timer_countdown_start_text,
    strings.feature_timer_reach_zero_hold_text,
    strings.feature_timer_activate_restart_text,
    strings.feature_timer_reset_text,
  ],
})
